/** Run a best-effort operation in isolation so a throw cannot break the caller's flow. */
export function runGuarded(operation: () => void): void {
  try {
    operation();
  } catch {
    // Swallowed by contract: the side effect is best-effort and must never propagate.
  }
}
